// assets/amk-variant-sync.js
// VAIL / AMK – sorgt dafür, dass die richtige Variant-ID im Produktformular landet.

(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function syncVariantId(picker, variantId) {
    if (!variantId) return;

    // Versuchen, den passenden Section-Container zu finden
    var sectionId = picker.getAttribute('data-section-id');
    var container = sectionId
      ? document.querySelector('[data-section-id="' + sectionId + '"]')
      : null;

    // Fallback: erstes product-form-component
    var productForm =
      (container && container.querySelector('product-form-component')) ||
      document.querySelector('product-form-component');

    if (!productForm) return;

    var idInput = productForm.querySelector('input[name="id"]');
    if (!idInput) return;

    idInput.value = variantId;
  }

  ready(function () {
    document.querySelectorAll('.variant-picker').forEach(function (picker) {
      // Radio-Buttons (Button-Style Varianten)
      var radios = picker.querySelectorAll('input[type="radio"][data-variant-id]');
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          var variantId = radio.getAttribute('data-variant-id');
          syncVariantId(picker, variantId);
        });
      });

      // Dropdown-Varianten
      var selects = picker.querySelectorAll('select.variant-option__select');
      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          var option = select.selectedOptions && select.selectedOptions[0];
          if (!option) return;
          var variantId = option.getAttribute('data-variant-id');
          syncVariantId(picker, variantId);
        });
      });

      // Initialer Sync: aktuell ausgewählte Variante beim Laden setzen
      var checked = picker.querySelector(
        'input[type="radio"][data-variant-id]:checked'
      );
      if (checked) {
        syncVariantId(picker, checked.getAttribute('data-variant-id'));
      } else {
        var firstSelect = picker.querySelector('select.variant-option__select');
        if (firstSelect && firstSelect.selectedOptions.length) {
          var opt = firstSelect.selectedOptions[0];
          var id = opt.getAttribute('data-variant-id');
          if (id) syncVariantId(picker, id);
        }
      }
    });
  });
})();
